import React from 'react';
import styled from 'styled-components';

export const BadgeTitle = ({ title }: { title: string }) => <Title>{title}</Title>;

const Title = styled.span`
  text-transform: capitalize;
  display: block;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  margin-bottom: 4px;
`;
